import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController, LoadingController } from 'ionic-angular';
import { GoogleMaps, GoogleMap, GoogleMapsEvent, GoogleMapOptions, Marker } from '@ionic-native/google-maps';
// import { Geolocation } from '@ionic-native/geolocation';

/**
 * Generated class for the MedlocViewmapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-medloc-viewmap',
  templateUrl: 'medloc-viewmap.html',
})
export class MedlocViewmapPage {

 @ViewChild('mapCanvass') mapElement: ElementRef;
 map: GoogleMap = null;

// your location
  plat: any;
  plon: any;

// store location
  blat: any;
  blon: any;

// branch name
  branchName: string;
  strDistance: any;


  constructor(public navCtrl: NavController, public navParams: NavParams
  	, private viewCtrl: ViewController
  	, private loadingCtrl: LoadingController
  	) {
  }

  ionViewDidLoad() {
    this.plat = this.navParams.get('plat');
    this.plon = this.navParams.get('plon');

    this.blat = this.navParams.get('blat');
    this.blon = this.navParams.get('blon');

    this.branchName = this.navParams.get('branch');

    this.loadLocations();

  }

  ionViewDidEnter() {
  	
  }

  loadLocations() {
  	let lat = this.blat;
  	let lon = this.blon;

  	let _lat = this.plat;
  	let _lon = this.plon;

  	this.strDistance = 'Your distance from the store is: ' + this.computeDistance(_lat, _lon, lat, lon, 'K' ).toFixed(2) + ' km';

  	let ico = {
  		url: 'assets/imgs/sjd_pin.png',
  		size: {
  			width: 35,
  			height: 40
  		}
  	};


  	let mapOptions: GoogleMapOptions = {
	  camera: {
	     target: {
	       lat: lat,
	       lng: lon
	     },
	     zoom: 10
	   },
	   mapType: 'MAP_TYPE_ROADMAP'
	};

	let loading = this.loadingCtrl.create({
		content: 'Loading Map',
		enableBackdropDismiss: true
	});

	loading.present();

	let element = this.mapElement.nativeElement;

	this.map  = GoogleMaps.create(element, mapOptions);

	this.map.one(GoogleMapsEvent.MAP_READY).then(() => {

		// Store

  		this.map.addMarker({
		  title: this.branchName,
	      icon: ico,
	      animation: 'DROP',
	      position: {
	        lat: lat,
	        lng: lon
	      }
	    }).then((marker: Marker) => {
		  	marker.on(GoogleMapsEvent.MARKER_CLICK).subscribe(() => {
		  	marker.setTitle(this.branchName);
	  		marker.showInfoWindow();
	  		loading.dismiss();
	  		  
	    	});
		});

		// You

		this.map.addMarker({
		  title: 'You are here!',
	      icon: 'red',
	      animation: 'DROP',
	      position: {
	        lat: _lat,
	        lng: _lon
	      }
	    }).then((marker: Marker) => {
		  	marker.on(GoogleMapsEvent.MARKER_CLICK).subscribe(() => {
		  	marker.setTitle('You are here!');
	  		marker.showInfoWindow();
	  		  loading.dismiss();
		    });
		});

		loading.dismiss();


  	}).catch((err)=> {
  		loading.dismiss();
  		alert('Please check your mobile or wifi connection to show map ' + err);
  		// loading.dismiss();
  	});

  }

 
  computeDistance(lat1, lon1, lat2, lon2, unit) {
  	var radlat1 = Math.PI * lat1/180
	var radlat2 = Math.PI * lat2/180
	var theta = lon1-lon2
	var radtheta = Math.PI * theta/180
	var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
	if (dist > 1) {
		dist = 1;
	}
	dist = Math.acos(dist)
	dist = dist * 180/Math.PI
	dist = dist * 60 * 1.1515
	if (unit=="K") { dist = dist * 1.609344 }
	if (unit=="N") { dist = dist * 0.8684 }
	return dist
  }

  cancelForm() {
    this.viewCtrl.dismiss(false);
  }

  ionViewWillLeave() {

    const nodeList = document.querySelectorAll('._gmaps_cdv_');

    for (let k = 0; k < nodeList.length; ++k) {
        nodeList.item(k).classList.remove('_gmaps_cdv_');
    }

  }



}



// WEBPACK FOOTER //
// ./src/pages/medloc-viewmap/medloc-viewmap.ts